import { Card } from "@/components/ui/card";
import ProjectCard from "./ProjectCard";

interface ProjectListProps {
  projects: Array<{
    id: string;
    title: string;
    year: number;
    description?: string;
    url?: string;
    technologies?: string[];
  }>;
  onEdit: (project: any) => void;
}

const ProjectList = ({ projects, onEdit }: ProjectListProps) => {
  return (
    <div className="space-y-6">
      {projects.length === 0 ? (
        <p className="text-gray-500 text-center py-4">
          No projects added yet. Click the edit button to add your first project.
        </p>
      ) : (
        projects.map((project) => (
          <ProjectCard 
            key={project.id} 
            project={project} 
            onEdit={onEdit}
          />
        ))
      )}
    </div>
  );
};

export default ProjectList;